import { render, staticRenderFns } from "./interviewDetail.vue?vue&type=template&id=50380dec&scoped=true&"
import script from "./interviewDetail.vue?vue&type=script&lang=js&"
export * from "./interviewDetail.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/interview/interviewDetail.less?vue&type=style&index=0&id=50380dec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50380dec",
  null
  
)

component.options.__file = "interviewDetail.vue"
export default component.exports